import { createFileRoute } from "@tanstack/react-router";
import { ariVerificationRoute } from "@/features/ari-verification";

export const Route = createFileRoute("/ari/verify")({
    ...ariVerificationRoute,
});
